module.exports = __webpack_public_path__ + "img/dialog-icon1.b22726b8.svg";